// @flow

import React, { Component, Fragment } from 'react';
//types
import { type Currencies } from '../../../../utilities/types';
import { type DirectMerchantDetail } from '../types';
import {
  SmDesktop,
  Tablet,
  Mobile,
  NotLgDesktop
} from '../../../../components/Responsive';
import { LgDesktop, Desktop, Default } from '../../../../components/Responsive';
import { ModelListTd } from '../../../../components/ModelListStyles';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import DirectMerchantTableRowExpanded from './DirectMerchantTableRowExpanded';
import { formatDate } from '../../../../utilities/misc';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  data: DirectMerchantDetail,
  currencies: Currencies,
  expandedRow: number,
  expandRow: (id: number) => void,
  tableBodyOptions: {
    selectedIso: string
  }
};

export default class DirectMerchantTableRow extends Component<Props> {
  handleClick = () => {
    this.props.expandRow(this.props.data.transaction_id);
  };
  renderExpandedDetailRow = (data: DirectMerchantDetail, colSpan: number) => (
    <NotLgDesktop>
      <DirectMerchantTableRowExpanded
        data={data}
        colSpan={colSpan}
        currencies={this.props.currencies}
      />
    </NotLgDesktop>
  );
  render() {
    const expanded = this.props.expandedRow === this.props.data.transaction_id;
    const currency = this.props.currencies[
      this.props.tableBodyOptions.selectedIso
    ];
    return (
      <Fragment key={this.props.data.transaction_id}>
        <DefaultModelRowTr
          onClick={this.handleClick}
          expanded={expanded}
          highlighted={expanded}
        >
          <Desktop>
            <ModelListTd>{formatDate(this.props.data.created_at)}</ModelListTd>
          </Desktop>
          <LgDesktop>
            <ModelListTd>{this.props.data.transaction_id}</ModelListTd>
          </LgDesktop>
          <ModelListTd>{this.props.data.merchant_name}</ModelListTd>
          <Default>
            <ModelListTd right>
              {formatCurrency(this.props.data.transaction_amount, currency)}
            </ModelListTd>
          </Default>
          <Desktop>
            <ModelListTd right>
              {formatCurrency(this.props.data.transaction_fee, currency)}
            </ModelListTd>
          </Desktop>
          <ModelListTd right>
            {formatCurrency(this.props.data.revenue_share, currency)}
          </ModelListTd>
        </DefaultModelRowTr>
        {this.props.expandedRow === this.props.data.transaction_id && (
          <>
            <SmDesktop>
              {this.renderExpandedDetailRow(this.props.data, 5)}
            </SmDesktop>
            <Tablet>{this.renderExpandedDetailRow(this.props.data, 3)}</Tablet>
            <Mobile>{this.renderExpandedDetailRow(this.props.data, 2)}</Mobile>
          </>
        )}
      </Fragment>
    );
  }
}
